// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__gIowe","title":"BackImages_title__2_ZYW","images":"BackImages_images__3ASxF"};